module.exports = __webpack_public_path__ + "static/media/ico_cnf_ext-10.e4b3fd99.svg";